"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ThemeContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _theme = _interopRequireDefault(require("../styles/theme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ThemeContext = (0, _react.createContext)(_theme.default);
exports.ThemeContext = ThemeContext;

var ThemeProvider = function ThemeProvider(props) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? _theme.default : _props$theme,
      children = props.children;
  return (0, _core.jsx)(ThemeContext.Provider, {
    value: theme
  }, children);
};

var _default = ThemeProvider;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ThemeContext, "ThemeContext", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/ThemeProvider.tsx");
  reactHotLoader.register(ThemeProvider, "ThemeProvider", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/ThemeProvider.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/styles/ThemeProvider.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvVGhlbWVQcm92aWRlci50c3giXSwibmFtZXMiOlsiVGhlbWVDb250ZXh0IiwiZGVmYXVsdFRoZW1lIiwiVGhlbWVQcm92aWRlciIsInByb3BzIiwidGhlbWUiLCJjaGlsZHJlbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQTs7QUFFQTs7Ozs7Ozs7Ozs7OztBQU1PLElBQU1BLFlBQVksR0FBRywwQkFBY0MsY0FBZCxDQUFyQjs7O0FBRVAsSUFBTUMsYUFBb0QsR0FBRyxTQUF2REEsYUFBdUQsQ0FBQ0MsS0FBRCxFQUFXO0FBQUEscUJBQzNCQSxLQUQyQixDQUM5REMsS0FEOEQ7QUFBQSxNQUM5REEsS0FEOEQsNkJBQ3RESCxjQURzRDtBQUFBLE1BQ3hDSSxRQUR3QyxHQUMzQkYsS0FEMkIsQ0FDeENFLFFBRHdDO0FBR3RFLFNBQU8sZUFBQyxZQUFELENBQWMsUUFBZDtBQUF1QixJQUFBLEtBQUssRUFBRUQ7QUFBOUIsS0FBc0NDLFFBQXRDLENBQVA7QUFDRCxDQUpEOztlQU1lSCxhOzs7Ozs7Ozs7Ozs7MEJBUkZGLFk7MEJBRVBFLGEiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgY3JlYXRlQ29udGV4dCwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBkZWZhdWx0VGhlbWUsIHsgVGhlbWUgfSBmcm9tICcuLi9zdHlsZXMvdGhlbWUnO1xuXG5leHBvcnQgdHlwZSBUaGVtZVByb3ZpZGVyUHJvcHMgPSB7XG4gIHRoZW1lPzogVGhlbWU7XG59O1xuXG5leHBvcnQgY29uc3QgVGhlbWVDb250ZXh0ID0gY3JlYXRlQ29udGV4dChkZWZhdWx0VGhlbWUpO1xuXG5jb25zdCBUaGVtZVByb3ZpZGVyOiBGdW5jdGlvbkNvbXBvbmVudDxUaGVtZVByb3ZpZGVyUHJvcHM+ID0gKHByb3BzKSA9PiB7XG4gIGNvbnN0IHsgdGhlbWUgPSBkZWZhdWx0VGhlbWUsIGNoaWxkcmVuIH0gPSBwcm9wcztcblxuICByZXR1cm4gPFRoZW1lQ29udGV4dC5Qcm92aWRlciB2YWx1ZT17dGhlbWV9PntjaGlsZHJlbn08L1RoZW1lQ29udGV4dC5Qcm92aWRlcj47XG59O1xuXG5leHBvcnQgZGVmYXVsdCBUaGVtZVByb3ZpZGVyO1xuIl19